import { SecondaryService } from "../Types";
import moment from "moment";

const AppointementAdviceText = (
  doctorName?: String,
  recoveryDate?: Date | null,
  receommendedServices?: SecondaryService[]
) => {
  let adviceText = "";
  if (doctorName && recoveryDate) {
    adviceText += `Dr. ${doctorName} expects you to recover by ${moment(
      recoveryDate
    ).format("MMM DD")}. `;
  }
  const doctorRecommendedServices = (receommendedServices ?? []).filter(
    (service) => service?.doctor_prescribed).length > 0
  if (doctorRecommendedServices) {
    adviceText += `To ensure a smooth and timely recovery, they have recommended the following support.`;
  }
    return adviceText;
};

export default AppointementAdviceText;